import { render, staticRenderFns } from "./CreditorsInfo.vue?vue&type=template&id=5e196cc0&scoped=true"
import script from "./CreditorsInfo.vue?vue&type=script&lang=js"
export * from "./CreditorsInfo.vue?vue&type=script&lang=js"
import style0 from "./CreditorsInfo.vue?vue&type=style&index=0&id=5e196cc0&prod&scoped=true&lang=scss"
import style1 from "./CreditorsInfo.vue?vue&type=style&index=1&id=5e196cc0&prod&scoped=true&lang=scss"
import style2 from "./CreditorsInfo.vue?vue&type=style&index=2&id=5e196cc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e196cc0",
  null
  
)

export default component.exports